import React, { useMemo, useState } from "react";

import { Grid } from "@mui/material";
import MarketTable from "./MarketTable";
import MarketTabs from "./MarketTabs";
import SearchInput from "components/SearchInput";
import { search } from "utils/helpers/search";
import { useSelector } from "react-redux";
import BrokerSelect from "./BrokerSelect";

function AdvancedTradeMarket() {
  const [value, setValue] = useState();

  const investmentMarketList = useSelector(
    (state) => state.market.investmentMarketList?.data
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setValue(value);
  };

  const searchedInvestmentMarketList = useMemo(() => {
    return search({
      list: investmentMarketList,
      value,
      keys: ["coinSourceName", "coinDestinationName"],
    });
  }, [investmentMarketList, value]);

  return (
    <Grid container maxHeight="1020px" overflow="auto" pl={2}>
      <Grid item xs={12} mx={1} mb={1}>
        <BrokerSelect />
      </Grid>

      <Grid item xs={12} mx={1} mb={1}>
        <MarketTabs />
      </Grid>

      <Grid item xs={12} mb={1}>
        <SearchInput value={value} onChange={handleSearch} />
      </Grid>

      <Grid item xs={12}>
        <MarketTable investmentMarketList={searchedInvestmentMarketList} />
      </Grid>
    </Grid>
  );
}

export default AdvancedTradeMarket;
